import { IService } from '../service.interface';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import ListResponse from '../../models/list-response.model';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';
@Injectable()
export class ServiceImpl<T> implements IService<T> {
  'httpClient': HttpClient;
  apiUrl: string = '';
  resource: string = '';

  constructor() {
    this.apiUrl = environment.apiUrl;
  }

  getAll(): Observable<Array<T>> {
    return this.httpClient
      .get(this.getFullPath())
      .pipe(map((res: any) => res.data));
  }

  get(id: string): Observable<T> {
    return this.httpClient
      .get(this.getFullPath() + id)
      .pipe(map((res: any) => <T>res.data));
  }

  getWithoutSpinner(path: string): any {
    const headers = new HttpHeaders().set('Skip-Spinner', 'true');
    return this.httpClient
      .get(this.getFullPath() + path, { headers: headers} )
      .pipe(map((res: any) => res));
  }

  postWithoutSpinner(data: any, path?: string): Observable<any> {
    if (!path) {
      path = '';
    }
    const headers = new HttpHeaders().set('Skip-Spinner', 'true');
    return this.httpClient
      .post(this.getFullPath() + path, data, { headers: headers})
      .pipe(map((res: any) => res.data));
  }

  updateWithoutSpinner(id: string, data: T): Observable<string> {
    const headers = new HttpHeaders().set('Skip-Spinner', 'true');
    return this.httpClient
      .put(this.getFullPath() + id, data, { headers: headers})
      .pipe(map((res: any) => res));
  }

  deleteWithoutSpinner(id: string): Observable<string> {
    return this.httpClient
      .delete(this.getFullPath() + id)
      .pipe(map((res: any) => res.data));
  }

  save(data: any): Observable<number> {
    return this.httpClient
      .post(this.getFullPath(), data)
      .pipe(map((res: any) => res.data));
  }

  update(id: string, data: T): Observable<string> {
    return this.httpClient
      .put(this.getFullPath() + id, data)
      .pipe(map((res: any) => res));
  }

  delete(id: string): Observable<string> {
    return this.httpClient
      .delete(this.getFullPath() + id)
      .pipe(map((res: any) => res.data));
  }

  post(data: any, path?: string): Observable<any> {
    if (!path) {
      path = '';
    }
    return this.httpClient
      .post(this.getFullPath() + path, data)
      .pipe(map((res: any) => res.data));
  }

  filter(filter: any): Observable<ListResponse<T>> {
    const parsedFilter = this.filterEmptyProperties(filter);
    // console.log('after', parsedFilter);
    return this.httpClient
      .get(this.getFullPath(), { params: parsedFilter })
      .pipe(map((res: any) => {
        return res;
      }));
  }

  executeGet(path: string): any {
    return this.httpClient
      .get(this.getFullPath() + path)
      .pipe(map((res: any) => res));
  }

  executeGetPDF(path: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.httpClient
      .get(this.getFullPath() + path, {
        headers: headers,
        responseType: 'blob',
      })
      .pipe(map((res: any) => res));
  }

  executeGetVideo(path: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'video/mp4');
    return this.httpClient
      .get(this.getFullPath() + path, {
        headers: headers,
        responseType: 'blob',
      })
      .pipe(map((res: any) => res));
  }

  executeDelete(path: string): Observable<any> {
    return this.httpClient
      .delete(this.getFullPath() + path)
      .pipe(map((res: any) => res));
  }

  protected getFullPath() {
    return this.apiUrl + this.resource;
  }

  getExtendedByIdBase(id: any): Observable<any> {
    const path = `${id}/extended`;
    return this.executeGet(path).pipe(map((res: any) => res.data));
  }

  getFilterExtendedBase(filter: any): Observable<any> {
    const path = `filter-extended`;
    filter = _.omitBy(filter, [_.isUndefined, _.isNull, _.isEmpty]);
    return this.httpClient
      .get(this.getFullPath() + path, { params: filter })
      .pipe(map((res: any) => res));
  }

  filterEmptyProperties(obj: any) {
    const result: any = {};
    for (const key in obj) {
      if (
        Object.prototype.hasOwnProperty.call(obj, key) &&
        obj[key] !== '' &&
        obj[key] !== null &&
        obj[key] !== undefined
      ) {
        result[key] = obj[key];
      }
    }
    return result;
  }
}
